import { makeStyles } from "@material-ui/core/styles";
import { useState, useEffect } from "react";
import {
  Paper,
  FormControl,
  Button,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Switch
} from "@material-ui/core";
import {CSVLink} from "react-csv"
import {preventDoubleClick} from "./preventDC.js"
import {
    fetchtripsbybookingdate,
    searchconvTripsbyDate,
    searchconvTripsbyDate2,
    fetchTripsbyStatus,
    searchhotTripsbyDate,
    searchhotTripsbyDate2,
    fetchEmployees,
    searchQuotesbyDate,
    fetchtripsbyairline,
    fetchSuppliers,
    TestTC,
    searchboTripsbyDate,
    searchQCbyDate,
    searchQEbyDate,
    newsearchQEbyDate,
    fetchquotefromtrip,
    searchpotentialTripsbyDate,
    searchTripsbyDate,
    searchTripsbyStartDate,
    fetchQuotebyId
  } from "../api/customerapi";
  import { DataGrid } from "@mui/x-data-grid";
  import GetRole from "./user";
  import DateCalc, {getSumByKey2, getmonth, removeDuplicates, getconvtarget, getquality, newgetqualitylead, DateCalc2} from "./date";

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(2),
      width: theme.spacing(30),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      textAlign: "left",
    },
    headertext: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(3),
    },
    button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: theme.spacing(24),
      height: theme.spacing(5),
      marginTop: theme.spacing(2.5),
      marginBottom: theme.spacing(1),
      fontSize: 14,
    },
    button2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: theme.spacing(24),
      height: theme.spacing(5),
      marginTop: theme.spacing(2.5),
      marginBottom: theme.spacing(1),
      fontSize: 14,
    },
  }));

export default function Productanalytics() {
    const width = window.innerWidth - 200;
    const columns4 = [
       {
          field: "tour_id",
          headerName: "Tour Id",
          width: (width / 12),
          cellClassName: "gridcell",
        },
        {
          field: "name",
          headerName: "Name",
          width: (width / 12) * 4,
          cellClassName: "gridcell",
        },
        {
          field: "city",
          headerName: "City",
          width: (width / 12)*2 ,
          cellClassName: "gridcell",
        },
    
        {
          field: "quoted_rncount",
          headerName: "Quoted RN",
          width: (width / 12) ,
        },
        {
          field: "quoted_share",
          headerName: "Quoted %",
          width: (width / 12) ,
        },
        {
          field: "conv_rncount",
          headerName: "Converted RN",
          width: (width / 12) ,
        },
        {
          field: "conv_share",
          headerName: "Conv %",
          width: (width / 12) ,
        },
      ];
      const columns2 = [
        {
          field: "supplier_name",
          headerName: "Name",
          width: (width / 12) * 2,
          cellClassName: "gridcell",
        },
    
        {
          field: "unique",
          headerName: "Unique",
          width: (width / 12) * 2,
        },
        {
          field: "count",
          headerName: "Count",
          width: (width / 12) * 2,
        },
        {
          field: "amount",
          headerName: "Total",
          width: (width / 12) * 2,
        },
        {
          field: "paid_amount",
          headerName: "Paid",
          width: (width / 12) * 2,
        },
        {
          field: "type",
          headerName: "Type",
          width: (width / 12) * 2,
        },
      ];
      const columns3 = [
        {
          field: "trips",
          headerName: "Trips",
          width: (width / 12),
          cellClassName: "gridcell",
        },
    
        {
          field: "active_trips",
          headerName: "Active Trips",
          width: (width / 12) ,
        },
        {
          field: "current_hot",
          headerName: "Current Hot",
          width: (width / 12) ,
        },
        {
          field: "total_hot",
          headerName: "Total Hot",
          width: (width / 12) ,
        },
        {
          field: "converted",
          headerName: "Converted",
          width: (width / 12) ,
        },
        {
          field: "conv_target",
          headerName: "Target Conv",
          width: (width / 12) ,
        },
        {
          field: "conv_target_till_date",
          headerName: "Target Conv till date",
          width: (width / 12) ,
        },
        {
          field: "hot_target",
          headerName: "Target Hot",
          width: (width / 12) ,
        },
        {
          field: "hot_target_till_date",
          headerName: "Target Hot till date",
          width: (width / 12) ,
        },
      ];
      const columns7 = [
        {
          field: "mode",
          headerName: "Mode",
          width: (width / 12) * 2,
          cellClassName: "gridcell",
        },
    
        {
          field: "count",
          headerName: "Count",
          width: (width / 12) * 2,
        },
        {
          field: "count_perc",
          headerName: "%",
          width: (width / 12) * 2,
        },
      ];

      const columns5 = [
        {
          field: "dest",
          headerName: "Dest",
          width: (width / 12),
          cellClassName: "gridcell",
        },
        {
          field: "trips",
          headerName: "# Trips",
          width: (width / 12),
          cellClassName: "gridcell",
        },
    
        {
          field: "qe",
          headerName: "Trips with QE",
          width: (width / 12)*2,
        },
        {
          field: "hot",
          headerName: "Hot",
          width: (width / 12),
        },
        {
          field: "conv",
          headerName: "Conv",
          width: (width / 12),
        },
        {
          field: "l2c",
          headerName: "T2C",
          width: (width / 12),
        },
        {
          field: "t2h",
          headerName: "T2H",
          width: (width / 12),
        },
        {
          field: "num_quotes",
          headerName: "# Quotes",
          width: (width / 12),
        },
        {
          field: "qbyt",
          headerName: "Quote/Trip",
          width: (width / 12),
        },
      ];

       const columns6 = [
       
    
        {
          field: "trip_id",
          headerName: "Trip Id",
          width: (width / 12) * 2,
        },
        {
          field: "dest",
          headerName: "Destination",
          width: (width / 12) * 2,
        },
         {
          field: "date",
          headerName: "Date",
          width: (width / 12) * 2,
        },
         {
          field: "airline",
          headerName: "Name",
          width: (width / 12) * 2,
          cellClassName: "gridcell",
        },
        {
          field: "amount",
          headerName: "Total",
          width: (width / 12) * 2,
        },
        {
          field: "status",
          headerName: "Status",
          width: (width / 12) * 2,
        },
       
      ];

      const headers5=[
        {label:"Destination", key:"dest"},
    {label:"Trips", key:"trips"},
    {label:"QE", key:"qe"},
    {label:"Hot", key:"hot"},
    {label:"Conv", key:"conv"},
    {label:"L2C", key:"l2c"},
    {label:"T2H", key:"t2h"},
    {label:"# Quotes", key:"num_quotes"},
    {label:"Quote/Trip", key:"qbyt"},
      ]

      const headers4=[
    {label:"Name", key:"name"},
    {label:"Tour Id", key:"tour_id"},
    {label:"City", key:"city"},
    {label:"Quoted RN", key:"quoted_rncount"},
    {label:"Quoted %", key:"quoted_share"},
    {label:"Converted RN", key:"conv_rncount"},
    {label:"Conv %", key:"conv_share"},
    
      ]

      const headers6=[
        {label:"Destination", key:"dest"},
    {label:"Trip Id", key:"trip_id"},
    {label:"Amount", key:"amount"},
    {label:"Date", key:"date"},
    {label:"Status", key:"status"},
    {label:"Airline", key:"airline"},
    
      ]

      const headers9=[
        {label:"Name", key:"name"},
           {label:"Id", key:"tour_id"},
    {label:"City", key:"city"},
    {label:"Quoted RN Count", key:"quoted_rncount"},
    {label:"Quoted %", key:"quoted_share"},
    {label:"Converted RN", key:"conv_rncount"},
    {label:"Conv %", key:"conv_share"},
    
      ]
    const { cuser, role, employeelist, destinationlist, loading } = GetRole();
    const classes = useStyles();
    const [searchData4, setsearchData4] = useState({});
    const [searchData7, setsearchData7] = useState({});
    const [searchData5, setsearchData5] = useState({});
    const [searchData2, setsearchData2] = useState({});
    const [searchData20, setsearchData20] = useState({});
    const [searchData3, setsearchData3] = useState({});
    const [searchData, setsearchData] = useState({});
    const [filterData, setfilterData] = useState({});
    const [filterData2, setfilterData2] = useState({});
    const [emp, setemp] = useState([]);
    const [sData, setsData] = useState([]);
    const [dest, setdest] = useState([]);
    const [listquoteData, setlistquoteData] = useState([]);
     const [tlsplist, settlsplist] = useState([]);
    const [listquoteData3, setlistquoteData3] = useState([]);
    const [listairlineData, setlistairlineData] = useState([]);
    const [listtripData, setlisttripData] = useState([]);
    const [listtripData2, setlisttripData2] = useState([]);
    const [listhottripData2, setlisthottripData2] = useState([]);
    const [listconvtripData2, setlistconvtripData2] = useState([]);
    const [listqetripData2, setlistqetripData2] = useState([]);
    const [listconvquoteData, setlistconvquoteData] = useState([]);
    const [listtourData, setlisttourData] = useState([]);
    const [tripscreated, settripscreated]  = useState([]);
    const [activetrips, setactivetrips]  = useState([]);
    const [hottrips, sethottrips]  = useState([]);
    const [hottripscreated, sethottripscreated]  = useState([]);
    const [convtrips, setconvtrips]  = useState([]);
  
    const getsuppliers = async () => {
      try{
      //console.log(tripData.primary_destination)
      //const data = await fetchSuppliersbyDest(tripData.primary_destination);
      const data = await fetchSuppliers();
  
          setsData(data.data)
        }catch(err){
          console.log(err)
        }
    };

    const getEmployees = async () => {
      try{
      const data = await fetchEmployees();
      //const custdatalistfromdb= data.data
  
      const empsplist = data.data.filter((emp) => emp.role == "Sales" || emp.role == "TL" || emp.role == "SME");
      const empshortname = empsplist.map((emp) => emp.short_name);
      let sortedemp = empshortname.sort()
      const result=groupBy(empsplist, v=>v.reporting_manager)
      console.log(result)
      var tllist=[]
      for (const [key, value] of result) {
      var temp={
        tl:key,
        sp:value.map(v=>v.short_name)
      }
      tllist=[...tllist, temp]
    }
    settlsplist(tllist)
      setemp(sortedemp);
    }catch(err){
      console.log(err)
    }
    };

    const gettl=(owner)=>{
  var temp=tlsplist.filter(t=>t.sp.includes(owner))
  if(temp.length>0){
return temp[0].tl
  }else{
return ""
  }
  
}

    const getsuppliertype=(name)=>{
      const type=sData.filter(sup => sup.supplier_name==name)
      //console.log(type)
       return type.length>0?type[0].supplier_type:""
    }
  
    const getDest = async () => {
      try{
      //console.log(destinationlist)
      //const temp=destinationlist.filter(d=>"order" in d)
      setdest(destinationlist);
    }catch(err){
      console.log(err)
    }
    }

    const changemonth=(value)=>{
      var x=getmonth(value)
      //console.log(x)
      setsearchData3({...searchData3, start_date:new Date(x.startdate), end_date:new Date(x.enddate), month:value})
    }
  
    useEffect(() => {
      
      // if(employeelist && employeelist.length>0){
      //   getEmployees();
      // }
      // if(destinationlist && destinationlist.length>0){
      //     getDest()
      // }
       if (!loading) {
      getDest()
      getEmployees()
      //getDest()
      getsuppliers()
       }
    }, [cuser, role, employeelist, destinationlist, loading]);

  const handlehealthSearch=async()=>{
    try{
      const data=await searchTripsbyDate(searchData5.start_date,searchData5.end_date)
      setlisttripData2(data.data)
      console.log(data.data)
      const data2=await searchhotTripsbyDate(searchData5.start_date,searchData5.end_date)
      console.log(data2.data)
      const unique=removeDuplicates(data2.data, "trip_id")
      setlisthottripData2(unique)
      console.log(unique)
      const data3=await searchconvTripsbyDate(searchData5.start_date,searchData5.end_date)
      const unique2=removeDuplicates(data3.data, "trip_id")
      setlistconvtripData2(unique2)
      console.log(data3.data)
      const data4=await newsearchQEbyDate(searchData5.start_date,searchData5.end_date)
      //const temp1=data4.data.filter(trip=>new Date(trip.createdAt).getTime() !== new Date(trip.updatedAt).getTime())
      const unique3=removeDuplicates(data4.data, "trip_id")
      setlistqetripData2(unique3)
      console.log(data4.data)

    }catch(e){
      console.log(e)
    }
  }

    const handlehotelSearch = async (e) => {
        try{
        // console.log(searchData2)
        if (searchData4.start_date && searchData4.end_date && searchData4.destination) {
          const data = await searchQuotesbyDate(
            searchData4.start_date,
            searchData4.end_date,
            searchData4.destination
          );
          setlistquoteData(data.data);

          const data2 = await searchconvTripsbyDate(
            searchData4.start_date,
            searchData4.end_date,
          );
          const temp=data2.data.filter(trip=>trip.primary_destination==searchData4.destination)
          //console.log(temp)
          let temp2=[]
          for(let i=0; i<temp.length; i++) {
            const data3=await fetchQuotebyId(temp[i].conv_quote)
            temp2=[...temp2, data3.data]
          }
          setlistconvquoteData(temp2);
    
          //console.log(data.data)
        } else {
          alert(
            "Please enter all parameters -destination, start date and end date before search"
          );
        }
      }catch(err){
        console.log(err)
      }
      };

      const handletourSearch = async (e) => {
        try{
        // console.log(searchData2)
        if (searchData.start_date && searchData.end_date && searchData.destination) {
          const data = await searchQuotesbyDate(
            searchData.start_date,
            searchData.end_date,
            searchData.destination
          );
          setlisttourData(data.data);
          var ed=DateCalc2(searchData.end_date, 10)
          const data2 = await searchconvTripsbyDate(
            searchData.start_date,
            ed,
          );
          console.log(data2.data)
          const temp=data2.data.filter(trip=>trip.primary_destination==searchData.destination)
          console.log(temp)
          let temp2=[]
          for(let i=0; i<temp.length; i++) {
            const data3=await fetchQuotebyId(temp[i].conv_quote)
            temp2=[...temp2, data3.data]
          }
          setlistconvquoteData(temp2);
    
          console.log(temp2)
        } else {
          alert(
            "Please enter all parameters -destination, start date and end date before search"
          );
        }
      }catch(err){
        console.log(err)
      }
      };

      const handletripSearch = async (e) => {
        try{
        // console.log(searchData2)
        if (searchData2.start_date && searchData2.end_date) {
          const data = await searchconvTripsbyDate(
            searchData2.start_date,
            searchData2.end_date,
            
          );
          setlisttripData(data.data);
    
          //console.log(data.data)
        } else {
          alert(
            "Please enter all parameters -start date and end date before search"
          );
        }
      }catch(err){
        console.log(err)
      }
      };

      const handletripSearch2 = async (e) => {
        try{
        // console.log(searchData2)
        if (searchData2.start_date && searchData2.end_date) {
          const data = await fetchtripsbybookingdate(
            searchData2.start_date,
            searchData2.end_date,
            
          );
          setlisttripData(data.data);
    
          console.log(data.data)
        } else {
          alert(
            "Please enter all parameters -start date and end date before search"
          );
        }
      }catch(err){
        console.log(err)
      }
      };

       const handleairlineSearch = async (e) => {
        try{
        // console.log(searchData2)
        if (searchData20.start_date && searchData20.end_date) {
          const data = await fetchtripsbyairline(
            searchData20.start_date,
            searchData20.end_date,
            
          );
          setlistairlineData(data.data);
    
          console.log(data.data)
        } else {
          alert(
            "Please enter all parameters -start date and end date before search"
          );
        }
      }catch(err){
        console.log(err)
      }
      };

      const handlequoteSearch=async()=>{
        try{
        if (searchData7.start_date && searchData7.end_date) {
          const data = await searchQCbyDate(
            searchData7.start_date,
            searchData7.end_date
          );
            //console.log(data.data.length)
          const temp=data.data.filter(q=>"base_quote_params" in q && "budget" in q.base_quote_params && q.base_quote_params.budget !=="" && q.base_quote_params.cust_type !=="")
          const temp3=data.data.filter(q=>"base_quote_params" in q && "special" in q.base_quote_params && q.base_quote_params.special !=="")
          console.log(temp3)
          setlistquoteData3(temp);
          
          // const Ind=data.data.filter(q=>q.primary_destination=="Bali")
          //console.log(data.data)
        } else {
          alert(
            "Please enter all parameters -start date and end date before search"
          );
        }
      }catch(err){
        console.log(err)
      }
      }

      const handledestSearch=async()=>{
        try{
          if (searchData3.start_date && searchData3.end_date) {
            const data = await searchTripsbyDate(
              searchData3.start_date,
              searchData3.end_date
            );
            //console.log(data.data.length)
            settripscreated(data.data)
            const data2 = await fetchTripsbyStatus("Active");
            //console.log(data2.data.length)
            setactivetrips(data2.data)
            const data5 = await fetchTripsbyStatus("Hot");
            //console.log(data5.data.length)
            sethottrips(data5.data)
            const data3 = await searchhotTripsbyDate2(
              searchData3.start_date,
              searchData3.end_date
            );
            const temp2=removeDuplicates(data3.data, "trip_id")
            sethottripscreated(temp2)
            const data4 = await searchconvTripsbyDate2(
              searchData3.start_date,
              searchData3.end_date
            );
            const temp=removeDuplicates(data4.data, "trip_id")
            setconvtrips(temp)
          }
        }catch(err){
          console.log(err)
        }
      }
      var finarr2=[]
      if(tripscreated.length > 0){
        var tc=[...tripscreated], at=[...activetrips], ht=[...hottrips], ct=[...convtrips], htc=[...hottripscreated]
        
        if(searchData3.destination){
          tc=tripscreated.filter(t=>t.primary_destination==searchData3.destination)
          at=activetrips.filter(t=>t.primary_destination==searchData3.destination)
          ht=hottrips.filter(t=>t.primary_destination==searchData3.destination)
          htc=hottripscreated.filter(t=>t.primary_destination==searchData3.destination)
          ct=convtrips.filter(t=>t.primary_destination==searchData3.destination)
        }
        console.log(new Date().getDate())
        finarr2=[{
          trips:tc.length,
          active_trips:at.length,
          current_hot:ht.length,
          total_hot:htc.length,
          converted:ct.length,
          conv_target:getconvtarget(searchData3.destination, searchData3.month),
          conv_target_till_date:Math.ceil(getconvtarget(searchData3.destination, searchData3.month)*new Date().getDate()/30),
          hot_target:getconvtarget(searchData3.destination, searchData3.month)*4,
          hot_target_till_date:Math.ceil(getconvtarget(searchData3.destination, searchData3.month)*new Date().getDate()/6),
        }]
      }
     // console.log(finarr2)
      var finarr=[]
      if(listquoteData3.length>0){
        var temparr=[...listquoteData3]
        if(filterData.destination){
          temparr=temparr.filter(q=>q.primary_destination==filterData.destination)
        }
        if(filterData.owner){
          temparr=temparr.filter(q=>q.trip_owner==filterData.owner)
        }
        if(filterData.sample){
          temparr=temparr.filter(q=>q.sample_package==filterData.sample)
        }
        if(filterData.special){
          temparr=temparr.filter(q=>q.base_quote_params.special==filterData.special)
        }
        if(filterData.edit_count){
          if(filterData.edit_count=="5+"){
            temparr=temparr.filter(q=>q.edit_count>5)
          }else{
          temparr=temparr.filter(q=>q.edit_count==filterData.edit_count)
          }
        }
        var result2
        if(filterData.mode=="Cust Type"){
          result2=groupBy(temparr, v=>v.base_quote_params.cust_type)
        }else{
          result2=groupBy(temparr, v=>v.base_quote_params.budget)
        }
    
        //var finarr=[]
        for (let [key, value] of result2) {
          const temp2={
            mode:key,
            count:value.length,
            count_perc:(value.length/temparr.length).toFixed(2),
          }//console.log(key + " = " + value.length);
          finarr=[...finarr, temp2]
          }
          const temp3={
            mode:"Total",
            count:temparr.length,
            count_perc:"1",
          }
          finarr=[...finarr, temp3]
          console.log((finarr))
        //setlistquoteData2(finarr);
      }

      const splitKeyValue = (obj,name) => {
        const keys = Object.keys(obj);
        const res = [];
        for(let i = 0; i < keys.length; i++){
            const temp={
                'name': keys[i],
            }
            temp[name]=obj[keys[i]]
           
           res.push(temp)
        };
        return res;
     };
     function groupBy(list, keyGetter) {
      const map = new Map();
      list.forEach((item) => {
           const key = keyGetter(item);
           const collection = map.get(key);
           if (!collection) {
               map.set(key, [item]);
           } else {
               collection.push(item);
           }
      });
      return map;
    }
    const getSumByKey = (arr, key) => {
      return arr.reduce(
        (accumulator, current) => accumulator + (Number(current[key])?Number(current[key]):0),
        0
      );
    };

    function mergeArrayObjects(arr1,arr2){
       
      let merge = [];
    
      for(let i=0;i<arr1.length;i++){
          let flag=0
          for(let j=0;j<arr2.length;j++){
              if(arr1[i].name==arr2[j].name){
                  merge.push({...arr1[i],...arr2[j]});
                  flag=1
              }
              
          }
          if(!flag){
              merge.push({...arr1[i]});
          }
      }
      return merge;
    }

    const getcity=(hc, name)=>{
      //console.log(hc)
      const temp=hc.filter(data=>data.hotel==name)
      //console.log(temp)
      return temp[0] && "city" in temp[0]?temp[0].city:""
    }

        //-----------------------------------------------------------------------------------hoteldata creation
        var analyticsdatalistdisplay4=[]
        var finalhotellist=[...listquoteData]
        if(searchData4.owner){
          finalhotellist=listquoteData.filter(t=>t.trip_owner==searchData4.owner)
         }
      if(searchData4 && searchData4.start_date && searchData4.end_date){
 
  const hotellist=[]
  var hotelcity=[]
  var analytics4 = [];
  var analytics5 = [];
  for(let i=0; i<finalhotellist.length; i++){
    const daydata=finalhotellist[i].day
    for(let j=0; j<daydata.length-1; j++) {
      const temp={
        hotel:daydata[j].hotel_name,
        city:daydata[j].city,
      }
      hotelcity.push(temp)
      if(searchData4.category && searchData4.type){
        if(daydata[j].hotel_category==searchData4.category && finalhotellist[i].trip_details[0].type_of_vacation==searchData4.type){
        hotellist.push(daydata[j].hotel_name+"-||-"+daydata[j].hotel_id+"-||-"+daydata[j].city);
      }
    }else if(searchData4.category){
        if(daydata[j].hotel_category==searchData4.category){
        hotellist.push(daydata[j].hotel_name+"-||-"+daydata[j].hotel_id+"-||-"+daydata[j].city);
      }
    }else if(searchData4.type){
      if(finalhotellist[i].trip_details[0].type_of_vacation==searchData4.type){
        hotellist.push(daydata[j].hotel_name+"-||-"+daydata[j].hotel_id+"-||-"+daydata[j].city);
      }
    }else{
        hotellist.push(daydata[j].hotel_name+"-||-"+daydata[j].hotel_id+"-||-"+daydata[j].city);
      }
      
    }
  }

  //console.log(hotellist)
  const count = {};

  hotellist.forEach(element => {
  count[element] = (count[element] || 0) + 1;
});

  //console.log(count)
  

 analytics4=splitKeyValue(count, "quoted_rn")

 var hotellist2=[]
//  const convquotelist=finalhotellist.filter(quote => quote.trip_status && (quote.trip_status=="Converted" || quote.trip_status=="Closed" ))
//  console.log(convquotelist)
const convquotelist=[...listconvquoteData]
  for(let i=0; i<convquotelist.length; i++){
    const daydata2=convquotelist[i].day
    for(let j=0; j<daydata2.length-1; j++) {
      if(searchData4.category && searchData4.type){
        if(daydata2[j].hotel_category==searchData4.category && convquotelist[i].trip_details[0].type_of_vacation==searchData4.type){
        hotellist2.push(daydata2[j].hotel_name+"-||-"+daydata2[j].hotel_id+"-||-"+daydata2[j].city);
      }
    }else if(searchData4.category){
        if(daydata2[j].hotel_category==searchData4.category){
        hotellist2.push(daydata2[j].hotel_name+"-||-"+daydata2[j].hotel_id+"-||-"+daydata2[j].city);
      }
    }else if(searchData4.type){
      if(convquotelist[i].trip_details[0].type_of_vacation==searchData4.type){
        hotellist2.push(daydata2[j].hotel_name+"-||-"+daydata2[j].hotel_id+"-||-"+daydata2[j].city);
      }
    }else{
        hotellist2.push(daydata2[j].hotel_name+"-||-"+daydata2[j].hotel_id+"-||-"+daydata2[j].city);
      }
    }
  }
  const count2 = {};

  hotellist2.forEach(element => {
  count2[element] = (count2[element] || 0) + 1;
});

    analytics5=splitKeyValue(count2,"conv_rn")

    

      //console.log(analytics4)
      //console.log(analytics5)
    const analytics6=mergeArrayObjects(analytics4,analytics5)
    let totalconvrn=getSumByKey(analytics6,"conv_rn")
    let totalquotedrn=getSumByKey(analytics6,"quoted_rn")
      
 analyticsdatalistdisplay4 = analytics6.map((data) => ({
    name: data.name.split("-||-").slice(0,1),
    tour_id: data.name.split("-||-").slice(1,2),
    city: data.name.split("-||-").slice(2,3),
    id: analytics6.indexOf(data),
    quoted_rncount: data.quoted_rn,
    quoted_share: data.quoted_rn?(data.quoted_rn/totalquotedrn).toFixed(2):0,
    conv_rncount: data.conv_rn,
    conv_share:data.conv_rn?(data.conv_rn/totalconvrn).toFixed(2):0,
  }));

}  

    //console.log(listconvquoteData)
     //-----------------------------------------------------------------------------------tourdata creation
     var analyticsdatalistdisplay=[]
     const tourlist=[]
     var analytics1 = [];
     var analytics2 = [];
     var finaltourlist=[...listtourData]
     if(searchData.owner){
      finaltourlist=listtourData.filter(t=>t.trip_owner==searchData.owner)
     }
     if(searchData && searchData.start_date && searchData.end_date){
     for(let i=0; i<finaltourlist.length; i++){
       const daydata=finaltourlist[i].day
       for(let j=0; j<daydata.length-1; j++) {
        if(searchData.type){
        if(searchData.type==finaltourlist[i].trip_details[0].type_of_vacation){
         tourlist.push(daydata[j].tour_name+"-||-"+daydata[j].tour_id);
        }
       }else{
        tourlist.push(daydata[j].tour_name+"-||-"+daydata[j].tour_id);
       }
      }
     }
   
     //console.log(hotellist)
     const tourcount = {};
   
     tourlist.forEach(element => {
     tourcount[element] = (tourcount[element] || 0) + 1;
   });
   
     //console.log(count)
  
   
    analytics1=splitKeyValue(tourcount, "quoted_rn")
   
    var tourlist2=[]
    // const convquotelist2=finaltourlist.filter(quote => quote.trip_status && (quote.trip_status=="Converted" || quote.trip_status=="Closed" ))
    const convquotelist2=[...listconvquoteData]
    //console.log(convquotelist2)
     for(let i=0; i<convquotelist2.length; i++){
       const daydata2=convquotelist2[i].day
       for(let j=0; j<daydata2.length-1; j++) {
        if(searchData.type){
          if(searchData.type==convquotelist2[i].trip_details[0].type_of_vacation){
           tourlist2.push(daydata2[j].tour_name+"-||-"+daydata2[j].tour_id);
          }
         }else{
          tourlist2.push(daydata2[j].tour_name+"-||-"+daydata2[j].tour_id);
         }
       }
     }
     const tourcount2 = {};
   
     tourlist2.forEach(element => {
     tourcount2[element] = (tourcount2[element] || 0) + 1;
   });
      //console.log(tourlist2)
       analytics2=splitKeyValue(tourcount2,"conv_rn")
   
      
   
         //console.log(analytics1)
         //console.log(analytics2)
       const analytics3=mergeArrayObjects(analytics1,analytics2)
       //console.log(analytics3)
       let totalconvrn=getSumByKey(analytics3,"conv_rn")
       let totalquotedrn=getSumByKey(analytics3,"quoted_rn")
   analyticsdatalistdisplay = analytics3.map((data) => ({
       name: data.name.split("-||-").slice(0,1),
       tour_id: data.name.split("-||-").slice(1,2),
       id: analytics3.indexOf(data),
       quoted_share:(data.quoted_rn/totalquotedrn).toFixed(2),
       conv_share:(data.conv_rn/totalconvrn).toFixed(2),
       quoted_rncount: data.quoted_rn,
       conv_rncount: data.conv_rn?data.conv_rn:0,
     }));
   
    }
    //-----------------------------------------------------------------------------------supplier data
    const getSumByKey3 = (arr, key) => {
      let sum=0
      for(let i=0;i<arr.length;i++){
        if(key in arr[i] && (arr[i].status=="Paid" || arr[i].status=="Paid by internal team")){
          sum=sum+arr[i][key]
        }else if(key in arr[i] && (arr[i].status=="Refund" || arr[i].status=="Refund claim by internal team")){
          sum=sum-arr[i][key]
        }else{
          sum=sum
        }
      }
      return sum
    };
    
    var finaltriplist=[...listtripData]
    var analyticsdatalistdisplay3=[]
    if(searchData2.destination){
      finaltriplist=finaltriplist.filter(t=>t.primary_destination==searchData2.destination)
     }
     if(searchData2 && searchData2.start_date && searchData2.end_date){
      var supplierlist=[]
      for(let i=0; i<finaltriplist.length; i++){
        if("supplier_payments" in finaltriplist[i]){
          for(let j=0;j<finaltriplist[i].supplier_payments.length;j++){
            var temp={...finaltriplist[i].supplier_payments[j], destination:finaltriplist[i].primary_destination, trip_id:finaltriplist[i].trip_id}
          supplierlist=[...supplierlist,temp]
          }
        }
      }

      const result=groupBy(supplierlist, v=>v.name)
      //console.log(result)
      var resultarr=[]
      for (let [key, value] of result) {
        var resultarr2=removeDuplicates(value, "trip_id")
        var temp={
          name:key,
          count:value.length,
          amount:getSumByKey2(value, "amount"),
          paid_amount: getSumByKey3(value, "amount"),
          unique:resultarr2.length,
          triparr:value.map(data=>data.trip_id)
        }
        resultarr=[...resultarr,temp]
        }

        const total={
          name:"Total",
          unique:getSumByKey2(resultarr, "unique"),
          count: getSumByKey2(resultarr, "count"),
          amount: getSumByKey2(resultarr, "amount"),
          paid_amount: getSumByKey2(resultarr, "paid_amount"),
        }
        
        resultarr.push(total)
        console.log(resultarr)
      analyticsdatalistdisplay3 = resultarr.map((data) => ({
        supplier_name: data.name,
        unique: data.unique,
        id: resultarr.indexOf(data),
        count: data.count,
        amount: data.amount,
        paid_amount:data.paid_amount,
        type:getsuppliertype(data.name),
      }));
     }
//--------------------------------------------------------------------------------------params data------------------------
     const analyticsdatalistdisplay7=finarr.map(data=>({
      mode:data.mode,
      count:data.count,
      count_perc:data.count_perc,
      id: finarr.indexOf(data),
     }))
     const gridcelldoubleclick=(name)=>{
      //console.log(name)
      const temp=resultarr.filter(data=>data.name==name)
      alert(temp[0].triparr)
      //console.log(temp[0].triparr)
      //console.log("/custdataentry/"+id);
    }

    const gridcellclickpayment = (id) => {
    window.open("/tripdataentry/" + id + "/paymentupdate",'_blank')
    //console.log("/custdataentry/"+id);
  };

    const analyticsdatalistdisplay8=finarr2.map(data=>({
      trips:data.trips,
      active_trips:data.active_trips,
      current_hot:data.current_hot,
      total_hot:data.total_hot,
      converted:data.converted,
      conv_target:data.conv_target,
      conv_target_till_date:data.conv_target_till_date,
      hot_target:data.hot_target,
      hot_target_till_date:data.hot_target_till_date,
      id: finarr2.indexOf(data),
     }))

     var healtharr=[]
     var temparr1=[...listtripData2], temparr2=[...listhottripData2], temparr3=[...listconvtripData2], temparr4=[...listqetripData2]
     if(listtripData2.length > 0){
     
      for (let i=0; i<dest.length; i++){
        if(dest[i]=="All" || dest[i]==""){
        
        }else{
          temparr1=listtripData2.filter(trip=>trip.primary_destination==dest[i])
          temparr2=listhottripData2.filter(trip=>trip.primary_destination==dest[i])
          temparr3=listconvtripData2.filter(trip=>trip.primary_destination==dest[i])
          temparr4=listqetripData2.filter(trip=>trip.primary_destination==dest[i])
          //temparr4=listqetripData2.filter(trip=>trip.primary_destination==dest[i] && new Date(trip.createdAt).getTime() !== new Date(trip.updatedAt).getTime())
        }
        if(filterData2.trip_owner){
          temparr1=temparr1.filter(trip=>trip.trip_owner==filterData2.trip_owner)
          temparr2=temparr2.filter(trip=>trip.trip_owner==filterData2.trip_owner)
          temparr3=temparr3.filter(trip=>trip.trip_owner==filterData2.trip_owner)
          temparr4=temparr4.filter(trip=>trip.trip_owner==filterData2.trip_owner)
          }
          if(filterData2.destination){
            temparr1=temparr1.filter(trip=>trip.primary_destination==filterData2.destination)
            temparr2=temparr2.filter(trip=>trip.primary_destination==filterData2.destination)
            temparr3=temparr3.filter(trip=>trip.primary_destination==filterData2.destination)
            temparr4=temparr4.filter(trip=>trip.primary_destination==filterData2.destination)
            }
            if(filterData2.quality){
              temparr1=temparr1.filter(trip=>(("lead") in trip)?(getquality(trip.lead.lead_status, trip.lead.time_to_book, trip.trip_channel, trip.trip_start_date,trip.lead.quality_upgrade,null)==filterData2.quality):(getquality(null, null, trip.trip_channel, trip.trip_start_date,null, null)==filterData2.quality))
              temparr2=temparr2.filter(trip=>(("lead") in trip)?(getquality(trip.lead.lead_status, trip.lead.time_to_book, trip.trip_channel, trip.trip_start_date,trip.lead.quality_upgrade,null)==filterData2.quality):(getquality(null, null, trip.trip_channel, trip.trip_start_date,null, null)==filterData2.quality))
              temparr3=temparr3.filter(trip=>(("lead") in trip)?(getquality(trip.lead.lead_status, trip.lead.time_to_book, trip.trip_channel, trip.trip_start_date,trip.lead.quality_upgrade,null)==filterData2.quality):(getquality(null, null, trip.trip_channel, trip.trip_start_date,null, null)==filterData2.quality))
              temparr4=temparr4.filter(trip=>(("lead") in trip)?(getquality(trip.lead.lead_status, trip.lead.time_to_book, trip.trip_channel, trip.trip_start_date,trip.lead.quality_upgrade,null)==filterData2.quality):(getquality(null, null, trip.trip_channel, trip.trip_start_date,null, null)==filterData2.quality))
              }
              if(filterData2.tl){
                 temparr1=temparr1.filter(trip=>gettl(trip.trip_owner)==filterData2.tl)
            temparr2=temparr2.filter(trip=>gettl(trip.trip_owner)==filterData2.tl)
            temparr3=temparr3.filter(trip=>gettl(trip.trip_owner)==filterData2.tl)
            temparr4=temparr4.filter(trip=>gettl(trip.trip_owner)==filterData2.tl)
              }
       
        var tempobj={
          dest:dest[i],
          trips:temparr1.length,
          num_quotes:temparr1.reduce((sum, obj) => sum + (obj.quote?.length || 0), 0),
          qe:temparr4.length+" ("+(temparr4.length/temparr1.length).toFixed(2)+")",
          hot:temparr2.length+" ("+(temparr2.length/temparr4.length).toFixed(2)+")",
          conv:temparr3.length+" ("+(temparr3.length/temparr2.length).toFixed(2)+")",
          l2c:(temparr3.length/temparr1.length*100).toFixed(2)+" %",
          t2h:(temparr2.length/temparr1.length*100).toFixed(2)+" %",
          qbyt:(temparr1.reduce((sum, obj) => sum + (obj.quote?.length || 0), 0)/temparr1.length).toFixed(2),
        }
        healtharr=[...healtharr, tempobj]
      }
      
     }

     const analyticsdatalistdisplay9=healtharr.map(data=>({
      dest:data.dest,
      num_quotes:data.num_quotes,
      trips:data.trips,
      qe:data.qe,
      hot:data.hot,
      conv:data.conv,
      l2c:data.l2c,
      t2h:data.t2h,
      qbyt:(data.num_quotes/data.trips).toFixed(2),
      id: healtharr.indexOf(data),
     }))

     const analyticsdatalistdisplay10=listairlineData.map(data=>({
      dest:data.primary_destination,
      airline:data.supplier_payments.airline_name,
       status:data.supplier_payments.status,
        amount:data.supplier_payments.amount,
         date:data.supplier_payments.date,
      trip_id:data.trip_id,
      id: listairlineData.indexOf(data),
     }))




  return (
    <div>
        <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Hotel Data
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Quoted On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData4({ ...searchData4, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Quoted On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData4({ ...searchData4, end_date: e.target.value })
            }
          />
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="destination">Destination</InputLabel>
            <Select
              displayEmpty
              className={classes.textField}
              labelId="Destination"
              required
              value={searchData4.destination}
              onChange={(e) =>
                setsearchData4({ ...searchData4, destination: e.target.value })
              }
            >
              {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="Category">Category</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="Category"
              value={searchData4.category}
              onChange={(e) =>
                setsearchData4({ ...searchData4, category: e.target.value })
              }
            >
              <MenuItem value={""}>Clear</MenuItem>
              <MenuItem value={1}>1</MenuItem>
              <MenuItem value={2}>2</MenuItem>
              <MenuItem value={3}>3</MenuItem>
              <MenuItem value={4}>4</MenuItem>
              <MenuItem value={5}>5</MenuItem>
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="Type">Type</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="Type"
              value={searchData4.type}
              onChange={(e) =>
                setsearchData4({ ...searchData4, type: e.target.value })
              }
            >
              <MenuItem value={""}>Clear</MenuItem>
              <MenuItem value={"Honeymoon"}>Honeymoon</MenuItem>
              <MenuItem value={"Anniversary"}>Anniversary</MenuItem>
              <MenuItem value={"Birthday"}>Birthday</MenuItem>
              <MenuItem value={"Break"}>Break</MenuItem>
              <MenuItem value={"Children-Special"}>Children-Special</MenuItem>
              <MenuItem value={"Nothing-Special"}>Nothing-Special</MenuItem>
              <MenuItem value={"Others"}>Others</MenuItem>
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">Trip Owner</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="owner"
              value={searchData4.owner}
              onChange={(e) =>
                setsearchData4({ ...searchData4, owner: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
             {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
          <Button
            onClick={handlehotelSearch}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
        </div>
          {analyticsdatalistdisplay4.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay4} headers={headers9}>Download CSV</CSVLink>
                   </div>
                ):("")}

        {analyticsdatalistdisplay4.length > 0 ? (
          <div style={{ height: 900, width: "100%" }}>
            <DataGrid
              rows={analyticsdatalistdisplay4}
              columns={columns4}
              autoPageSize
              // pageSize={10}
              // autoHeight
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>

      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
         Tour Data
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Quoted On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData({ ...searchData, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Quoted On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData({ ...searchData, end_date: e.target.value })
            }
          />
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="destination">Destination</InputLabel>
            <Select
              displayEmpty
              className={classes.textField}
              labelId="Destination"
              required
              value={searchData.destination}
              onChange={(e) =>
                setsearchData({ ...searchData, destination: e.target.value })
              }
            >
              {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="Type">Type</InputLabel>
            <Select
              
              className={classes.textField}
              labelId="Type"
              value={searchData.type}
              onChange={(e) =>
                setsearchData({ ...searchData, type: e.target.value })
              }
            >
              <MenuItem value={""}>Clear</MenuItem>
              <MenuItem value={"Honeymoon"}>Honeymoon</MenuItem>
              <MenuItem value={"Anniversary"}>Anniversary</MenuItem>
              <MenuItem value={"Birthday"}>Birthday</MenuItem>
              <MenuItem value={"Break"}>Break</MenuItem>
              <MenuItem value={"Children-Special"}>Children-Special</MenuItem>
              <MenuItem value={"Nothing-Special"}>Nothing-Special</MenuItem>
              <MenuItem value={"Others"}>Others</MenuItem>
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">Trip Owner</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="owner"
              value={searchData.owner}
              onChange={(e) =>
                setsearchData({ ...searchData, owner: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
             {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
             
            </Select>
          </FormControl>

          <Button
            onClick={handletourSearch}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
        </div>
         {analyticsdatalistdisplay.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay} headers={headers4}>Download CSV</CSVLink>
                   </div>
                ):("")}
        {analyticsdatalistdisplay.length > 0 ? (
          <div style={{ height: 900, width: "100%" }}>
            <DataGrid
              rows={analyticsdatalistdisplay}
              columns={columns4}
              autoPageSize
              // pageSize={10}
              // autoHeight
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>

      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
         Supplier Data
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Start Date"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData2({ ...searchData2, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="End Date"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData2({ ...searchData2, end_date: e.target.value })
            }
          />
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel >Destination</InputLabel>
            <Select
              displayEmpty
              className={classes.textField}
              labelId="Destination"
              required
              value={searchData2.destination}
              onChange={(e) =>
                setsearchData2({ ...searchData2, destination: e.target.value })
              }
            >
              <MenuItem value={""}>Clear</MenuItem>
              {dest && dest.length>0 && dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
            </Select>
          </FormControl>
         
          

          <Button
            onClick={handletripSearch}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search (Conv Date)
          </Button>
          <Button
            onClick={handletripSearch2}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search (Booking Date)
          </Button>
        </div>
        {analyticsdatalistdisplay3.length > 0 ? (
          <div style={{ height: 900, width: "100%" }}>
            <DataGrid
              rows={analyticsdatalistdisplay3}
              onCellDoubleClick={(getValue)=>gridcelldoubleclick(getValue.row.supplier_name)}
              columns={columns2}
              autoPageSize
            
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>

      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
         Flight Data
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Booked On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData20({ ...searchData20, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Booked On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData20({ ...searchData20, end_date: e.target.value })
            }
          />
        
         
          

          <Button
            onClick={handleairlineSearch}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
        </div>
        {analyticsdatalistdisplay10.length > 0 ? (
          <div style={{ height: 900, width: "100%" }}>
            <DataGrid
              rows={analyticsdatalistdisplay10}
              onCellDoubleClick={(getValue)=>gridcellclickpayment(getValue.row.trip_id)}
              columns={columns6}
              autoPageSize
            
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>

      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Quote Params
        </Typography>
   
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Created On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData7({ ...searchData7, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Created On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData7({ ...searchData7, end_date: e.target.value })
            }
          />

          <Button
            onClick={handlequoteSearch}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
          
         
        </div>
        <div align="center">
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="destination">Destination</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="Destination"
              value={filterData.destination}
              onChange={(e) =>
                setfilterData({ ...filterData, destination: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Meghalaya"}>Meghalaya</MenuItem>
              {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="edit_count">Edit Count</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="Edit Count"
              value={filterData.edit_count}
              onChange={(e) =>
                setfilterData({ ...filterData, edit_count: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={0}>0</MenuItem>
              <MenuItem value={1}>1</MenuItem>
              <MenuItem value={2}>2</MenuItem>
              <MenuItem value={3}>3</MenuItem>
              <MenuItem value={4}>4</MenuItem>
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={"5+"}>5+</MenuItem>
           
             
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="mode">Mode</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="Mode"
              value={filterData.mode}
              onChange={(e) =>
                setfilterData({ ...filterData, mode: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            
              <MenuItem value={"Budget"}>Budget</MenuItem>
              <MenuItem value={"Cust Type"}>Cust Type</MenuItem>
           
             
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="sample">Sample</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="Sample"
              value={filterData.sample}
              onChange={(e) =>
                setfilterData({ ...filterData, sample: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            
              <MenuItem value={"Yes"}>Yes</MenuItem>
              <MenuItem value={"No"}>No</MenuItem>
           
             
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="special">Special</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="Special"
              value={filterData.special}
              onChange={(e) =>
                setfilterData({ ...filterData, special: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Abu Dhabi stay"}>Abu Dhabi stay</MenuItem>
            <MenuItem value={"Bangkok-Pattaya"}>Bangkok-Pattaya</MenuItem>
            <MenuItem value={"Nusa Penida stay"}>Nusa Penida stay</MenuItem>
            <MenuItem value={"Gili stay"}>Gili stay</MenuItem>
            <MenuItem value={"2N Cruise"}>2N Cruise</MenuItem>
            <MenuItem value={"Bintan"}>Bintan</MenuItem>
            <MenuItem value={"Malaysia"}>Malaysia</MenuItem>
            <MenuItem value={"Cruise Stay"}>Cruise Stay</MenuItem> 
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">Trip Owner</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="owner"
              value={filterData.owner}
              onChange={(e) =>
                setfilterData({ ...filterData, owner: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
             {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
         
          </div>
        {analyticsdatalistdisplay7.length > 0 ? (
          <div style={{ height: 1200, width: "100%" }}>
            <DataGrid
              rows={analyticsdatalistdisplay7}
            
              columns={columns7}
              autoPageSize
              
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>

      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
         Destination Health
        </Typography>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Date On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData5({ ...searchData5, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Date On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setsearchData5({ ...searchData5, end_date: e.target.value })
            }
          />
          <Button
            onClick={handlehealthSearch}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="destination">Destination</InputLabel>
            <Select
              displayEmpty
              className={classes.textField}
              labelId="Destination"
              required
              value={searchData3.destination}
              onChange={(e) =>
                setfilterData2({ ...filterData2, destination: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
              {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="owner">Trip Owner</InputLabel>
            <Select
              displayEmpty
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
              labelId="owner"
              value={filterData2.trip_owner}
              onChange={(e) =>
                setfilterData2({ ...filterData2, trip_owner: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
             {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
             
            </Select>
          </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="quality">Quality</InputLabel>
            <Select
              displayEmpty
              className={classes.textField}
              labelId="Quality"
              required
              value={filterData2.quality}
              onChange={(e) =>
                setfilterData2({ ...filterData2, quality: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
            <MenuItem value={"Rhodium"}>Rhodium</MenuItem>
              <MenuItem value={"Platinum"}>Platinum</MenuItem>
                       <MenuItem value={"Diamond"}>Diamond</MenuItem>
                       <MenuItem value={"Titanium"}>Titanium</MenuItem>
                       <MenuItem value={"Gold"}>Gold</MenuItem>
                       <MenuItem value={"Silver"}>Silver</MenuItem>
                       <MenuItem value={"Copper"}>Copper</MenuItem>
                       <MenuItem value={"Iron"}>Iron</MenuItem>
                       <MenuItem value={"High Quality"}>High Quality</MenuItem> 
                       <MenuItem value={"Old High Quality"}>Old High Quality</MenuItem> 
             
            </Select>
          </FormControl>
            <FormControl
                      style={{
                        minWidth: 480,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 8,
                      }}
                    >
                      <InputLabel id="leadcancreason">TL</InputLabel>
                      <Select
                        
                        className={classes.textField}
                        labelId="leadcancreason"
                        value={filterData2.tl}
                        onChange={(e) =>
                          setfilterData2({ ...filterData2, tl: e.target.value })
                        }
                      >
                     <MenuItem value={""}>Clear</MenuItem>
                      {tlsplist && tlsplist.map(t=>
                      <MenuItem value={t.tl}>{t.tl}</MenuItem>
                      )}
                    
                    
                      </Select>
                    </FormControl>
        </div>
        {analyticsdatalistdisplay9.length>1?(<div>
                   <CSVLink data={analyticsdatalistdisplay9} headers={headers5}>Download CSV</CSVLink>
                   </div>
                ):("")}
        {analyticsdatalistdisplay9.length > 0 ? (
          <div style={{ height: 900, width: "100%" }}>
            <DataGrid
              rows={analyticsdatalistdisplay9}
              //onCellDoubleClick={(getValue)=>gridcelldoubleclick(getValue.row.supplier_name)}
              columns={columns5}
              autoPageSize
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>

      <Paper variant="outlined" className={classes.paper} elevation={10}>
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
         Destination Conversion status
        </Typography>
        <div align="center">
        
          <FormControl
              style={{
                minWidth: 120,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="month">Month</InputLabel>
              <Select
                classname={classes.textField}
                labelId="month"
                variant="outlined"
                value={searchData3.month}
                onChange={(e) => changemonth(e.target.value)}
              >
                
                <MenuItem value={"January 2024"}>January 2024</MenuItem>
                <MenuItem value={"February 2024"}>February 2024</MenuItem>
                <MenuItem value={"March 2024"}>March 2024</MenuItem>
                <MenuItem value={"April 2024"}>April 2024</MenuItem>
                <MenuItem value={"May 2024"}>May 2024</MenuItem>
                <MenuItem value={"June 2024"}>June 2024</MenuItem>
                <MenuItem value={"July 2024"}>July 2024</MenuItem>
                <MenuItem value={"August 2024"}>August 2024</MenuItem>
                <MenuItem value={"September 2024"}>September 2024</MenuItem>
                <MenuItem value={"October 2024"}>October 2024</MenuItem>
                <MenuItem value={"November 2024"}>November 2024</MenuItem>
                <MenuItem value={"December 2024"}>December 2024</MenuItem>
                <MenuItem value={"January 2025"}>January 2025</MenuItem>
                <MenuItem value={"February 2025"}>February 2025</MenuItem>
                <MenuItem value={"March 2025"}>March 2025</MenuItem>
                <MenuItem value={"April 2025"}>April 2025</MenuItem>
                <MenuItem value={"May 2025"}>May 2025</MenuItem>
                <MenuItem value={"June 2025"}>June 2025</MenuItem>
                <MenuItem value={"July 2025"}>July 2025</MenuItem>
                <MenuItem value={"August 2025"}>August 2025</MenuItem>
                <MenuItem value={"September 2025"}>September 2025</MenuItem>
                <MenuItem value={"October 2025"}>October 2025</MenuItem>
                <MenuItem value={"November 2025"}>November 2025</MenuItem>
                <MenuItem value={"December 2025"}>December 2025</MenuItem>
                <MenuItem value={"January 2026"}>January 2026</MenuItem>
                                <MenuItem value={"February 2026"}>February 2026</MenuItem>
                                <MenuItem value={"March 2026"}>March 2026</MenuItem>
                                <MenuItem value={"April 2026"}>April 2026</MenuItem>
                                <MenuItem value={"May 2026"}>May 2026</MenuItem>
                                <MenuItem value={"June 2026"}>June 2026</MenuItem>
                                <MenuItem value={"July 2026"}>July 2026</MenuItem>
                                <MenuItem value={"August 2026"}>August 2026</MenuItem>
                                <MenuItem value={"September 2026"}>September 2026</MenuItem>
                                <MenuItem value={"October 2026"}>October 2026</MenuItem>
                                <MenuItem value={"November 2026"}>November 2026</MenuItem>
                                <MenuItem value={"December 2026"}>December 2026</MenuItem>
                                <MenuItem value={"January 2027"}>January 2027</MenuItem>
                                                                <MenuItem value={"February 2027"}>February 2027</MenuItem>
                                                                <MenuItem value={"March 2027"}>March 2027</MenuItem>
                                                                <MenuItem value={"April 2027"}>April 2027</MenuItem>
                                                                <MenuItem value={"May 2027"}>May 2027</MenuItem>
                                                                <MenuItem value={"June 2027"}>June 2027</MenuItem>
                                                                <MenuItem value={"July 2027"}>July 2027</MenuItem>
                                                                <MenuItem value={"August 2027"}>August 2027</MenuItem>
                                                                <MenuItem value={"September 2027"}>September 2027</MenuItem>
                                                                <MenuItem value={"October 2027"}>October 2027</MenuItem>
                                                                <MenuItem value={"November 2027"}>November 2027</MenuItem>
                                                                <MenuItem value={"December 2027"}>December 2027</MenuItem>
              </Select>
              
            </FormControl>
          <FormControl
            style={{
              minWidth: 480,
              marginTop: 16,
              marginRight: 32,
              marginLeft: 8,
            }}
          >
            <InputLabel id="destination">Destination</InputLabel>
            <Select
              displayEmpty
              className={classes.textField}
              labelId="Destination"
              required
              value={searchData3.destination}
              onChange={(e) =>
                setsearchData3({ ...searchData3, destination: e.target.value })
              }
            >
            <MenuItem value={""}>Clear</MenuItem>
              {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
            </Select>
          </FormControl>
          
          

          <Button
            onClick={handledestSearch}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search
          </Button>
        </div>
        {analyticsdatalistdisplay8.length > 0 ? (
          <div style={{ height: 900, width: "100%" }}>
            <DataGrid
              rows={analyticsdatalistdisplay8}
              //onCellDoubleClick={(getValue)=>gridcelldoubleclick(getValue.row.supplier_name)}
              columns={columns3}
              autoPageSize
            ></DataGrid>
          </div>
        ) : (
          <div align="center">
            <h1>No data found</h1>
          </div>
        )}
      </Paper>
    </div>
  )
}
